module.exports = __webpack_public_path__ + "static/media/curcuma.c00e7817.png";